<div [ngClass]="{'md:grid grid-cols-3 items-start': wide}" class="flex flex-col">
  @if (showHeader) {
    <div class="flex flex-col">
      <h2 class="text-sm fw-bold">{{ shift.eventName }}</h2>
      <span class="font-light text-sm pb-2" [style.color]="shift.shardColor">{{ shift.shardName }}</span>
    </div>
  }
  <table class="text-sm border-separate border-spacing-x-3">
    <tbody>
    <tr>
      <td>Start:</td>
      <td class="w-full">
            <span *ngIf="shift.start;else noStart"
                  class="font-light">{{ shift.start | date: 'dd.MM.yyyy HH:mm' }}</span>
        <ng-template #noStart>
          <span class="font-light text-red-600">Keine Anfangszeit</span>
        </ng-template>
      </td>
    </tr>
    <tr>
      <td>Ende:</td>
      <td class="w-full">
        <span *ngIf="shift.end;else noEnd" class="font-light">{{ shift.end | date: 'dd.MM.yyyy HH:mm' }}</span>
        <ng-template #noEnd>
          <span class="font-light text-red-600">Keine Endzeit</span>
        </ng-template>
    </tr>
    <tr [ngClass]="{'md:hidden': wide}">
      <td class="text-right">
        <div class="w-full flex">
          <svg class="h-4 w-4 ml-auto" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m184.49 136.49l-80 80a12 12 0 0 1-17-17L159 128L87.51 56.49a12 12 0 1 1 17-17l80 80a12 12 0 0 1-.02 17"/>
          </svg>
        </div>
      </td>
      <td class="w-full">
        <span class="font-light">{{ shift.locationName }}</span>
      </td>
    </tr>
    </tbody>
  </table>
  <span [ngClass]="{'md:inline-flex': wide}" class="hidden">
    <svg class="h-4 w-4 place-self-center" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m184.49 136.49l-80 80a12 12 0 0 1-17-17L159 128L87.51 56.49a12 12 0 1 1 17-17l80 80a12 12 0 0 1-.02 17"/>
    </svg>
    <span class="font-light place-self-center pl-3">{{ shift.locationName }}</span>
  </span>
</div>
